import NewAddressSFC from "./NewAddress.vue";
export type { INewAddressEmits } from "./emits";
export type { INewAddressProps } from "./props";
export const NewAddress = NewAddressSFC;
